










































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import { reaction } from "mobx";
import requestStore from "@/store/requestStore";
import userStore from "@/store/userStore";
import ComboBox from "@/components/Forms/ComboBox.vue";
import SubmitForm from "@/components/Forms/SubmitForm.vue";
import TextField from "@/components/Forms/TextField.vue";
import Autocomplete from "@/components/Forms/Autocomplete.vue";
import RequestCreateBinDetails from "@/components/Requests/RequestCreateBinDetails.vue";
import RequestAddressFoundDialog from "@/components/Requests/RequestAddressFoundDialog.vue";
import { addDataCyToComboBox } from "@/UITestHelper/UITestHelper";
import router from "@/router";
import notificationStore from "@/store/notificationStore";
import LoadingPanel from "@/components/LoadingPanel.vue";
import { LoadingStore } from "@/store/loadingStore";
import { toShallowJsAsc, toShallowSortableJsAsc } from "@/helpers/observableHelper";

@Observer
@Component({
  components: {
    LoadingPanel,
    ComboBox,
    Autocomplete,
    TextField,
    SubmitForm,
    RequestCreateBinDetails,
    RequestAddressFoundDialog
  }
})
export default class RequestForm extends Vue {
  loading = new LoadingStore();
  requestStore = requestStore;
  disposeUserStore?: () => void;
  disposeRequestStore?: () => void;

  assessmentNumberApplied: boolean | undefined = false;
  addressFoundDialogOpen = false;

  dispose?: () => void;
  toShallowJsAsc = toShallowJsAsc;
  toShallowSortableJsAsc = toShallowSortableJsAsc;

  async mounted() {
    const addressFoundDialogOpenHandler = reaction(
      () => requestStore.AddressFoundDialogOpen,
      () => {
        this.addressFoundDialogOpen = requestStore.AddressFoundDialogOpen;
      },
      { fireImmediately: true }
    );

    const activeCouncilOpenHandler = reaction(
      () => userStore.activeCouncil,
      async () => {
        await requestStore.fetchCreateRequestData();
      },
      { fireImmediately: true }
    );

    const enableCreateRequestHandler = reaction(
      () => requestStore.enableCreateRequest,
      () => {
        if (!requestStore.enableCreateRequest) {
          router.push({ name: "Requests" });
        }
      },
      { fireImmediately: true }
    );

    this.dispose = () => {
      addressFoundDialogOpenHandler();
      activeCouncilOpenHandler();
      enableCreateRequestHandler();
    };

    addDataCyToComboBox();
  }

  destroyed() {
    this.clearSearch();
    if (this.dispose) this.dispose();
  }

  async applyFoundAddress() {
    this.requestStore.createRequestVm.unitNumber = this.requestStore.addressFound?.unitNumber ?? "";
    this.requestStore.createRequestVm.streetNumber = this.requestStore.addressFound?.streetNumber ?? "";
    this.requestStore.createRequestVm.streetName = this.requestStore.addressFound?.streetName ?? "";
    this.requestStore.createRequestVm.suburb = this.requestStore.addressFound?.suburb ?? "";
    this.requestStore.createRequestVm.postcode = this.requestStore.addressFound?.postcode ?? "";
    this.requestStore.createRequestVm.assessmentNumber = this.requestStore.addressFound?.assessmentNumber ?? "";
    this.requestStore.createRequestVm.addressBins = this.requestStore.addressFound?.addressBins ?? [];

    await this.createRequest();
  }

  async submitRequest() {
    try {
      if (this.requestStore.createRequestVm.assessmentNumber && !this.assessmentNumberApplied) {
        this.requestStore.addressFound = await requestStore.getAddressByAssessmentNumber(this.requestStore.createRequestVm.assessmentNumber);
        if (this.requestStore.addressFound) {
          requestStore.AddressFoundDialogOpen = true;
          return;
        }
      }

      await this.createRequest();
    } catch (error) {
      notificationStore.error("An unexpected error occurred while creating the request. Please try again later or contact support.");
    }
  }

  async createRequest() {
    await requestStore.CreateRequest();
    requestStore.allRequestsForToday = true;
    router.push({ name: "Requests" });
    notificationStore.success("Request Created");
  }

  async search() {
    if (!this.requestStore.createRequestVm.assessmentNumber) return;

    const assessmentNumberFound = await requestStore.searchAddressByAssessmentNumber(this.requestStore.createRequestVm.assessmentNumber);

    if (assessmentNumberFound) {
      this.assessmentNumberApplied = true;
    } else {
      this.requestStore.createRequestVm.unitNumber = "";
      this.requestStore.createRequestVm.streetNumber = "";
      this.requestStore.createRequestVm.streetName = "";
      this.requestStore.createRequestVm.suburb = "";
      this.requestStore.createRequestVm.postcode = "";
      this.requestStore.createRequestVm.addressBins = [];

      this.assessmentNumberApplied = false;

      notificationStore.error("Assessment number not found. Please enter the address information manually.");
    }
  }

  clearSearch() {
    this.assessmentNumberApplied = false;
    this.requestStore.resetCreateRequestEntries();
    this.requestStore.resetAddressFound();
  }
}
